import { combineReducers, configureStore } from '@reduxjs/toolkit';

import dialogReducer from 'feature/hooks/dialogSlice';
import downloadOtherSlice from 'feature/hooks/downloadOtherSlice';
import locationHookSlice from 'feature/hooks/locationSlice';
import progressIndicatorReducer from 'feature/progressIndicator/progressIndicatorSlice';
import billingReducer from '../feature/billing/billingSlice';
import claimReducer from '../feature/claims/claimSlice';
import claimsReducer from '../feature/claims/claimsSlice';
import complaintTrackingReducer from '../feature/complaintTracking/complaintTrackingSlice';
import formReducer from '../feature/form/formSlice';
import fraudTrackingReducer from '../feature/fraudTracking/fraudTrackingSlice';
import historyReducer from '../feature/history/historySlice';
import inputReducer from '../feature/input/inputSlice';
import memberReducer from '../feature/members/memberSlice';
import searchReducer from '../feature/search/searchSlice';
import settlementLettersReducer from '../feature/settlementLetters/settlementLettersSlice';
import tableSelectedItemsReducer from '../feature/tableSelectedItems/tableSelectedItemsSlice';
import textsLocalesReducer from '../feature/textsLocales/textsLocalesSlice';
import uploadReducer from '../feature/upload/uploadSlice';
import userReducer from '../feature/user/userSlice';
import healthCheckReducer from '../feature/utils/checkConnectionSlice';
import downloadReducer from '../feature/utils/downloaderSlice';

const rootReducer = {
	user: userReducer,
	progressIndicator: progressIndicatorReducer,
	search: searchReducer,
	hooks: combineReducers({
		dialog: dialogReducer,
		location: locationHookSlice,
		downloadOther: downloadOtherSlice,
	}),
	claims: claimsReducer,
	claim: claimReducer,
	form: formReducer,
	input: inputReducer,
	member: memberReducer,
	healthCheck: healthCheckReducer,
	billing: billingReducer,
	upload: uploadReducer,
	settlementLetters: settlementLettersReducer,
	textsLocales: textsLocalesReducer,
	fraudTracking: fraudTrackingReducer,
	complaintTracking: complaintTrackingReducer,
	tableSelectedItems: tableSelectedItemsReducer,
	history: historyReducer,
	downloader: downloadReducer
};

export const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
